export default "__VITE_ASSET__DgPKREs8__"